export const COLUMNS = {
  clientRole: 'clientRole',
  businessUnit: 'businessUnit',
  apSpendCategoryL1: 'apSpendCategoryL1',
  apSpendCategoryL2: 'apSpendCategoryL2',
  ruleId: 'ruleId',
};

export const GROUP_COLUMNS = ['clientRole', 'businessUnit'];

export const COLUMN_DEFS = [
  {
    field: COLUMNS.ruleId,
    filter: 'agNumberColumnFilter',
    width: 100,
  },
  {
    field: COLUMNS.clientRole,
  },
  {
    field: COLUMNS.businessUnit,
  },
  {
    headerName: 'Taxonomy',
    marryChildren: true,
    children: [
      {
        field: COLUMNS.apSpendCategoryL1,
        lockVisible: true,
        cellRenderer: 'ruleCellRenderer',
      },
      {
        field: COLUMNS.apSpendCategoryL2,
        lockVisible: true,
        cellRenderer: 'ruleCellRenderer',
      },
    ],
  },
];

export const gridConfig = {
  columnDefs: COLUMN_DEFS,
};

export default gridConfig;
